import { registerLicense } from "@syncfusion/ej2-base";

import { Router } from "./Router";

registerLicense(
	"ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkdjWH9Xc3FRTmVdWUE="
);

function App() {
	return <Router />;
}

export { App };
